import { GET_DEAL_CLAIMED_DETAIL } from '../Actions/actionTypes';
export default (state={},action)=>{
  switch(action.type){
    case GET_DEAL_CLAIMED_DETAIL:
      return action.payload;
    default:
      return state;
  }
}